import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ClientAppLogin, EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { BrandViewModel } from '../../../business-entities/brand.interface';
import { Customer } from '../../../business-entities/customer.interface';
import { DFVehicleModel, VehiclesViewModel } from '../../../business-entities/df-vehicle-details-model';
import { MobileValidationModel } from '../../../business-entities/mobile-number-validation.interface';
import { Features } from '../../../business-entities/step.class';
import { VehicleCustomerDetails } from '../../../business-entities/vehicle-customer-details.interface';
import { VehicleListViewModel } from '../../../business-entities/vehicle-list-view-model';
import { Vehicle } from '../../../business-entities/vehicle.interface';
import { VerifiedCustomer } from '../../../business-entities/verified-customer.interface';
import { WidgetCustomerVehicleDetails } from '../../../business-entities/widget-customer-vehicle-details-model';
import { AppointmentService } from '../../../business-services/appointment.service';
import { FindCarDataService } from '../../../data-services/find-car-data.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CustomerVehicleDetailsMultiple } from './../../../business-entities/customer-vehicle-response.interface';
import { FindCarSections } from './../../../business-entities/find-car-sections.interface';
import { FindCarService } from './../../../business-services/find-car.service';
import { CommonService } from './../../../services/commom.service';
import * as Constants from './../../../utils/contstants';
import * as Enums from './../../../utils/enums';
import { AddVehicleCustomerComponent } from './add-vehicle-cutomer/add-vehicle-customer.component';
import { ConfirmRegMobileNoComponent } from './confirm-reg-mobile-no/confirm-reg-mobile-no.component';
import { AddContactComponent } from './add-contact/add-contact.component';
import { AddVehicleCustomerModel } from '../../../business-entities/add-vehicle-customer-model';
import { SettingService } from '../../../business-services/setting.service';
import { SummaryService } from '../../../business-services/summary.service';
import { CountryISO } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-find-car',
  templateUrl: 'find-car.component.html',
  styleUrls: ['./find-car.component.css']
})
export class FindCarComponent implements OnInit {

  showTempOTPSection: boolean = false; // Temp Variable
  private readonly sectionConstants = Constants.findCarSectionConstant;
  sections: FindCarSections;
  vehicleCustomerDetailsSingle: VehicleCustomerDetails;
  vehicleCustomerDetailsMultiple: CustomerVehicleDetailsMultiple;
  existingVehicleCustomerDetails: WidgetCustomerVehicleDetails[];
  customerPhoneNumber: string;
  multipleCarSelectionForm: FormGroup;
  licensePlate: string;
  licenseFlag: string = 'false';
  mobileNumberFlag: string = 'false';
  brandList: BrandViewModel[];
  mobileCode: string;
  appData: any;
  mobileNumber: any;
  isAddedNewVehicle: boolean = false;
  licensePlateClass: string;
  userAuthMobilecode?: string = '';
  userForgotAuthMobilecode?: string = '';
  userForgotAuthCountryCode: string;
  isUserForgotAuthCountryCodeSet: boolean = false;
  OTP: string;
  customerGuid: string;
  successMsg: boolean = false;
  timerOn: boolean = true;
  minute: any
  second: any
  timeout: boolean = false;
  timeoutMessage: string;
  isAddCarAllowed: boolean;
  isWCVLS: boolean = false;//Widget - Customer Verification at last step
  isWSSBLP: boolean = false;//Widget - Step-1 Search by license plate
  isshowmobilenumber: boolean = false;
  isshowOTP: boolean = false;
  isWidgetVehicleDMSSearch: boolean;
  isOTP: boolean = true;
  features: Features[] = [];
  currentLanguage: string;
  showLPSearch: boolean = false;
  showVehicleDetail: boolean = false;
  hideMobileNo: boolean = false;
  vehicleNo: string = null;
  vehicleDetails: DFVehicleModel;
  vehicle: VehiclesViewModel;
  iscar: boolean = false;
  newVehicleDetails: Vehicle[] = [];
  newVehicle: VehicleListViewModel;
  viewModel: Vehicle;
  newviewModel: WidgetCustomerVehicleDetails;
  newCustomer: Customer;
  ISalreadyAddedLP: boolean = false;
  validOTP: boolean = false;
  existingCustomerID: number;
  existingcustomerGuid: string;
  otpTimer: string = '';
  isNewContact: boolean;
  selectedCustomerVehicleDetails: WidgetCustomerVehicleDetails;
  localVehicleDetails: WidgetCustomerVehicleDetails;
  excludeContries: string[] = [];
  VehicleSource: string = '';
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  @ViewChild('forgetRegPhoneNumberForm') public forgetRegPhoneNumberForm: NgForm;
  @ViewChild('PhoneNumberForm') public PhoneNumberForm: NgForm;
  @Output() openAnotherPanelRequest = new EventEmitter<string>();
  constructor(
    private readonly brandService: SummaryService,
    private readonly fcService: FindCarService,
    private readonly modelService: NgbModal,
    private readonly toastr: ToastrService,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly commonService: CommonService,
    private readonly globalSetting: GlobalSetting,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly cdref: ChangeDetectorRef,
    private readonly secureStorage: SecureStorage,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly findCarDataSevice: FindCarDataService,
    private readonly appointmentService: AppointmentService,
    private readonly vehicleService: FindCarDataService,
    private readonly settingService: SettingService,
    public datepipe: DatePipe
  ) {
    this.sections = {
      registrationNumberSection: true,
      forgetRegPhoneNumberSection: false,
      forgetRegOtpSection: false,
      carSelectionSingle: false,
      carSelectionMultiple: false
    };
    this.appData = this.commonService.getAppData();
  }

  ngOnInit(): void {
    this.onlyCountries= Constant.OnlyCountry;
    this.countryDialCodes= Constant.CountryDialCodes;
    this.customerPhoneNumber = this.commonService.getCustomerPhone();
    if (!this.userForgotAuthMobilecode) {
      this.userForgotAuthMobilecode = this.commonService.getUserAuthMobileCode();
    }
    this.getBrands();
    this.initializeCarDetails();
    this.newVehicleDetails = this.commonService.getNewVehicleArray();
    this.newVehicleDetails = (this.newVehicleDetails == undefined) ? [] : this.newVehicleDetails;
    this.getFeatures();
  }

  getFeatures() {
    this.currentLanguageService.featureList.subscribe((res) => {
      if (res?.length > 0) {
        this.features = this.settingService.features;
        let WCVLS = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WCVLS)
        this.isWCVLS = WCVLS ? WCVLS.isActive : false;
        let WSSBLP = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WSSBLP)
        this.isWSSBLP = WSSBLP ? WSSBLP.isActive : false;
        let addCar = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.AddCar);
        this.isAddCarAllowed = addCar ? addCar.isActive : false;
        let WidgetVehicleDMSSearch = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WidgetVehicleDMSSearch);
        this.isWidgetVehicleDMSSearch = WidgetVehicleDMSSearch ? WidgetVehicleDMSSearch.isActive : false;
      }
    });
  }

  getBrands() {
    this.globalSetting.isAuthenticated.subscribe((res)=>{
      if (res) {
        if(this.brandService.brandList.length === 0){
          this.brandService.getBrand().then(res => {
            if (res) {
              this.brandList = res as Array<BrandViewModel>;
              if (this.brandList) {
                return this.brandList;
              }
            }
          }
          )
        }
        else{
          this.brandList = this.brandService.brandList;
          return this.brandList;
        }  
      }
    });
  }
  getBrandLogo(brandCode) {
    if (this.brandList && this.brandList.length > 0) {
      const length = (brandCode) ? this.brandList.filter(x => x.brandCode.toUpperCase() === brandCode.toUpperCase()).length : 0;
      if (brandCode == null || brandCode == undefined || length == 0) {
        return '../../../assets/no-image-icon.png';
      }
      else {
        return this.brandList.filter(x => x.brandCode.toUpperCase() === brandCode.toUpperCase())[0].image
      }
    }
  }


  onRegistrationNumberFormSubmit(form: NgForm): void {
    if (this.licenseFlag != 'true') {
      const registrationNumber = form.value.registrationNumber;
      this.spinner.show();
      this.fcService.getCustomerAndVehicleDetails(registrationNumber)
        .then((result) => {
          const responseObject = result.responseObject;
          if (responseObject && responseObject.errorCount > 0) {
            const errorObject = responseObject.result;
            if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.LicensePlateNotFoundErrorCode) {
              this.modelService.open(ConfirmRegMobileNoComponent);
            }
          } else {
            this.vehicleCustomerDetailsSingle = responseObject.result as VehicleCustomerDetails;
            this.commonService.addCustomerAndVehicleDetailsSingle(this.vehicleCustomerDetailsSingle);
            this.changeSection(this.sectionConstants.carSelectionSingle);
          }
          this.spinner.hide();
        });
      this.licenseFlag = 'false';
    } else {
      if (form.value.registrationNumber == '' || isNullOrUndefined(form.value.registrationNumber)) {
        let errorMsg = this.translate.instant('lblPleaseEnterRegistrationNumber')
        this.toastr.error(errorMsg);
      } else {
        let errorMsg = this.translate.instant('lblPleaseEnterValidRegistrationNumber')
        this.toastr.error(errorMsg);
      }
    }
  }

  openAddCustomerVehicleModal(mobileForm: boolean, value: string, code: string, customerForm: boolean, vehicleDetails: DFVehicleModel, localVehicleDetails: WidgetCustomerVehicleDetails): void {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'lg'
    };
    const modelref = this.modelService.open(AddVehicleCustomerComponent, ngbModalOptions);
    modelref.componentInstance.mobileForm = mobileForm;
    modelref.componentInstance.customerForm = customerForm;
    if (mobileForm) {
      modelref.componentInstance.registrationNumber = value;
    } else {
      modelref.componentInstance.mobileNo = value;
      this.customerPhoneNumber = value;
      modelref.componentInstance.registrationNumber = this.vehicleNo;
    }
    modelref.componentInstance.mobileCode = code;
    modelref.componentInstance.vehicleDetails = vehicleDetails;
    modelref.componentInstance.localVehicleDetails = localVehicleDetails;
    modelref.result.then((response) => {
      if (response.success) {
        this.commonService.validateAddedCustomerDeatils();
        this.licensePlate = response.licensePlate;
        this.userAuthMobilecode = response.mobileCode;
        this.isAddedNewVehicle = true;
        this.commonService.addUserAuthMobile(response.mobileNumber);
        this.changeSection(this.sectionConstants.registrationNumberSection);
        this.getCarDetails();

        this.showLPSearch = false;
        this.sections.carSelectionMultiple = true;
        this.showTempOTPSection = false;
        this.hideMobileNo = true;
        this.iscar = true;
        const index = this.existingVehicleCustomerDetails?.length - 1;
        this.multipleCarSelectionForm = new FormGroup({
          selectedCar: new FormControl(index, [Validators.required])
        });

        // if new car added then select that new car and redirect to select service
        this.multipleCarSelectionForm.controls['selectedCar'].setValue(index);
        this.onMultipleCarSelectionFormSubmit()
      }
    });
  }

  openaddContactModal() {
    const modelref = this.modelService.open(AddContactComponent, { size: 'lg' });
    modelref.componentInstance.mobileNo = this.customerPhoneNumber;
    modelref.componentInstance.mobileCode = this.userForgotAuthMobilecode;
    modelref.result.then((_response) => {
      // This is intentional

    });
  }

  createNewVehicleModel(): WidgetCustomerVehicleDetails {
    let appdata = this.commonService.getAppData();
    let newVehicleCustomer = appdata.newVehicleCustomerModel;
    let brand = this.brandList.filter(s => s.brandName.toLowerCase() == newVehicleCustomer.MakeName.toLowerCase())
    let name; let address; let phone;
    if (this.vehicleDetails?.names.length > 0) {
      for (let i = 0; i < this.vehicleDetails.names.length; i++) {
        if (this.vehicleDetails.names[i].sources != null || this.vehicleDetails.names[i].sources != undefined) {
          for (const element of this.vehicleDetails.names[i].sources) {
            if (element.name == "DSF") {
              name = this.vehicleDetails.names[i];
              phone = this.vehicleDetails.phones[i];
              if (this.vehicleDetails.addresses.length > 0) {
                address = this.vehicleDetails.addresses[i];
              }
            }
            else {
              name = this.vehicleDetails.names[0];
              phone = this.vehicleDetails.phones[0];
              if (this.vehicleDetails.addresses.length > 0) {
                address = this.vehicleDetails.addresses[0];
              }
            }
          }
        }
        else {
          name = this.vehicleDetails.names[0];
          phone = this.vehicleDetails.phones[0];
          if (this.vehicleDetails.addresses.length > 0) {
            address = this.vehicleDetails.addresses[0];
          }
        }
      }
    }
    this.existingCustomerID = (this.existingCustomerID == undefined) ? null : this.existingCustomerID;
    this.existingcustomerGuid = (this.existingcustomerGuid == undefined) ? null : this.existingcustomerGuid;
    return {
      existingCustomerId: this.existingCustomerID,
      existingVehicleId: newVehicleCustomer.existingVehicleId,
      FIRST_NAME: newVehicleCustomer.FirstName,
      LAST_NAME: newVehicleCustomer.LastName,
      CUST_NAME: newVehicleCustomer.FirstName + ' ' + newVehicleCustomer.LastName,
      ADDRESS_LINE_1: newVehicleCustomer.Address1,
      ADDRESS_LINE_2: newVehicleCustomer.Address2,
      CITY: newVehicleCustomer.City,
      STATE: newVehicleCustomer.State,
      COUNTRY: newVehicleCustomer.Country,
      COUNTRY_ID: newVehicleCustomer.CountryId,
      PINCODE: newVehicleCustomer.Zipcode,
      CUST_EMAILID: newVehicleCustomer.Email,
      CUST_MOBILE_NO: newVehicleCustomer.MobileNo,
      DIAL_CODE: newVehicleCustomer.MobileCode,
      licensePlateNo: newVehicleCustomer.LicensePlate,
      companyMakeCode: (brand.length > 0) ? brand[0].brandCode : null,
      companyMakeName: newVehicleCustomer.MakeName,
      companyModel: newVehicleCustomer.Model,
      companyModelNo: newVehicleCustomer.ModelNo,
      color: newVehicleCustomer.color,
      year: newVehicleCustomer.Year,
      fuelType: newVehicleCustomer.fuelType,
      vehicleType: (newVehicleCustomer.vehicleGroup) == undefined ? newVehicleCustomer.vehicleType : newVehicleCustomer.vehicleGroup,
      transmission: newVehicleCustomer.transmission,
      chassisNo: newVehicleCustomer.chasisNo,
      OwnerName: newVehicleCustomer.OwnerName,
      ownerTypes: newVehicleCustomer.ownertypes.toString(),
      DFFIRST_NAME: name?.firstName,
      DFLAST_NAME: name?.lastName,
      DFCUST_NAME: name?.fullName,
      DFADDRESS_LINE_1: address?.address,
      DFADDRESS_LINE_2: null,
      DFCITY: address?.city,
      DFSTATE: null,
      DFCOUNTRY: null,
      DFCOUNTRY_ID: null,
      DFPINCODE: address?.postalCode,
      DFCUST_EMAILID: null,
      DFCUST_MOBILE_NO: phone?.number,
      DFDIAL_CODE: phone?.country,
      DFEngineSerialNo: null,
      DFCompanyModel: this.vehicleDetails?.vehicles[0]?.modelName,
      DFCompanyMakeName: this.vehicleDetails?.vehicles[0]?.brandName,
      DFRegistrationDate: this.vehicleDetails?.vehicles[0]?.firstRegistrationDate,
      DFColor: this.vehicleDetails?.vehicles[0]?.colorText,
      DFYear: this.vehicleDetails?.vehicles[0]?.modelYear,
      DFChassisNo: this.vehicleDetails?.vehicles[0]?.vehicleIdentificationNumber,
      DFFuelType: this.vehicleDetails?.vehicles[0]?.fuelTypeText,
      DFVehicleType: this.vehicleDetails?.vehicles[0]?.vehicleGroup,
      DFComplianceNumber: this.vehicleDetails?.vehicles[0]?.complianceNumber,
      DFRegistrationLastDate: this.vehicleDetails?.vehicles[0]?.lastRegistrationDate,
      DFTransmission: this.vehicleDetails?.vehicles[0]?.transmission,
      DFTotalWeight: this.vehicleDetails?.vehicles[0]?.totalWeight,
      DFCurbWeight: this.vehicleDetails?.vehicles[0]?.curbWeight,
      DFNumberOfAxles: this.vehicleDetails?.vehicles[0]?.noOfAxles,
      DFAxleWeightLimit_Front: this.vehicleDetails?.vehicles[0]?.axleWeightLimit_Front,
      DFAxleWeightLimit_Rear: this.vehicleDetails?.vehicles[0]?.axleWeightLimit_Rear,
      DFTyreDimension_Front: this.vehicleDetails?.vehicles[0]?.tyreDimension_Front,
      DFTyreDimension_Rear: this.vehicleDetails?.vehicles[0]?.tyreDimension_Rear,
      DFTyreLoadIndex_Front: this.vehicleDetails?.vehicles[0]?.tyreLoadIndex_Front,
      DFTyreLoadIndex_Rear: this.vehicleDetails?.vehicles[0]?.tyreLoadIndex_Rear,
      DFTyreSpeedIndex_Front: this.vehicleDetails?.vehicles[0]?.tyreSpeedIndex_Front,
      DFTyreSpeedIndex_Rear: this.vehicleDetails?.vehicles[0]?.tyreSpeedIndex_Rear,
      DFInspectionNextDate: this.vehicleDetails?.vehicles[0]?.nextInspectionDate,
      DFInspectionPrevDate: this.vehicleDetails?.vehicles[0]?.previousInspectionDate,
      DFOwnerType: this.vehicleDetails?.vehicles[0]?.ownerType,
      DFEnginePower_KW: this.vehicleDetails?.vehicles[0]?.enginePower_KW,
      DFEnginePower_HP: this.vehicleDetails?.vehicles[0]?.enginePower_HP,
      DFDoors: this.vehicleDetails?.vehicles[0]?.doors,
      latitude: 0.0,
      longitude: 0.0,
      customerGuid: this.existingcustomerGuid,
      vehicleGuid: newVehicleCustomer.vehicleGuid,
      nomineeName: null,
      nomineeMobileNumber: null,
      nomineeMobileCode: null,
      previousKilometer: (newVehicleCustomer.previousKilometer) ? newVehicleCustomer?.previousKilometer : 0,
      registrationDate: (newVehicleCustomer.registrationDate) ? newVehicleCustomer?.registrationDate : null,
      vehicleSource: this.VehicleSource,
      contactId: null,
      driverId: null
    }
  }
  onForgotRegistrationNumber(): void {
    this.changeSection(this.sectionConstants.forgetRegPhoneNumberSection);
  }
  initializeCustomer() {
    let obj = {
      firstName: '',
      lastName: '',
      customerGuid: '',
      email: '',
      state: '',
      country: '',
      countryId: 0,
      mobileCode: '',
      mobileNo: '',
      zipcode: '',
      city: '',
      address1: '',
      address2: '',
    }
    this.vehicleCustomerDetailsMultiple = {
      customerDetails: obj,
      vehicleDetails: []
    };
  }
  getCarDetails(): void {
    this.existingVehicleCustomerDetails = this.commonService.getExistingCustomerVehicleDetails();
    this.newviewModel = this.createNewVehicleModel();
    this.existingVehicleCustomerDetails = (this.existingVehicleCustomerDetails == null || this.existingVehicleCustomerDetails == undefined) ? [] : this.existingVehicleCustomerDetails;
    this.existingVehicleCustomerDetails.push(this.newviewModel);
    this.commonService.addExistingCustomerVehicleDetails(this.existingVehicleCustomerDetails);
  }
  async onForgotRegFormSubmit(form: NgForm): Promise<void> {
    if (this.mobileNumberFlag != 'true') {
      this.showTempOTPSection = false;
      this.hideMobileNo = true;
      this.customerPhoneNumber = form.value.mobileNo.number;
      this.commonService.addCustomerPhone(this.customerPhoneNumber);
      this.spinner.show();
      await this.generateAndSendOtp();
    } else if (form.value.mobileNo.number == '' || isNullOrUndefined(form.value.mobileNo.number)) {
        let errorMsg = this.translate.instant('lblPleaseEnterYourMobileNumber')
        this.toastr.error(errorMsg);
      } else {
        let errorMsg = this.translate.instant('lblPleaseEnterCorrectMobileNumber')
        this.toastr.error(errorMsg);
      }
    this.spinner.hide();
  }
  async getVehicleDetails(vehicleNo: string, isSearch: boolean) {
    this.spinner.show();
    await this.vehicleService.GetVehicleByLicensePlateNoOrVIN(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject?.errorCount > 0) {
          this.getDFVehicleDetails(vehicleNo, isSearch)
          this.spinner.hide();
        }
        else if (response.responseObject?.vehicleGuid == null) {
          this.toastr.warning('lblVehicleNotFoundContactSupport');
          this.spinner.hide();
        }
        else if (this.isWidgetVehicleDMSSearch && response.responseObject?.driverId !== null) {
          const addVehicleCustomer: AddVehicleCustomerModel = this.createAddCustomerVehicleResponseModel(response.responseObject);
          this.commonService.addNewVehicleCustomer(addVehicleCustomer);
          this.commonService.vehicleId = response.responseObject?.vehicleGuid;
          this.getCarDetails();
          const index = this.existingVehicleCustomerDetails?.length - 1;
          this.multipleCarSelectionForm = new FormGroup({
            selectedCar: new FormControl(index, [Validators.required])
          });
          this.multipleCarSelectionForm.controls['selectedCar'].setValue(index);
          this.onMultipleCarSelectionFormSubmit()
          this.initializeCarDetails();
          this.spinner.hide();
        }
        else {
          this.localVehicleDetails = response.responseObject;
          this.VehicleSource = this.localVehicleDetails.vehicleSource
          this.vehicleDetails = null;
          this.commonService.vehicleId = response.responseObject?.vehicleGuid;
          this.existingVehicleCustomerDetails = this.commonService.getExistingCustomerVehicleDetails();
          let existVehicle = this.existingVehicleCustomerDetails.filter(vehicle => vehicle.licensePlateNo == this.localVehicleDetails.licensePlateNo)
          if (existVehicle.length > 0) {
            let alreadyAddedLP = this.translate.instant('lblalreadyAddedLP')
            this.toastr.warning(alreadyAddedLP);
            this.ISalreadyAddedLP = true;
            this.spinner.hide();
          }
          else if (!this.isWSSBLP) {
            this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
            this.spinner.hide();
          }
          else {
            this.isshowmobilenumber = true;
            this.licensePlate = this.vehicleNo;
            this.changePanelTitle();
            this.vehicleNo = this.licensePlate;
            this.spinner.hide();
          }
        }
      }
    },
      _error => {
        this.spinner.hide();
      });

  }

  createAddCustomerVehicleResponseModel(response: any): AddVehicleCustomerModel {
    return {
      //previousKilometer?
      Zipcode: '',
      FirstName: '',
      LastName: '',
      Address1: '',
      Address2: '',
      ZipCode: '',
      City: '',
      //State?
      Country: '',
      CountryId: 0,
      MobileNo: '',
      MobileCode: '',
      Email: '',
      LicensePlate: response.licensePlateNo,
      Model: response.companyModel,
      //ModelNo?
      fuelType: response.fuelType,
      //color?
      //Year?
      //vehicleGroup?
      //transmission?
      MakeName: response.companyMakeName,
      SourceOfCreation: '',
      ownertypes: [''],
      //OwnerName?
      //chasisNo?
      //complianceNumber?
      //registrationLastDate?
      //registrationDate?
      //totalWeight?
      //curbWeight?
      //noOfAxles?
      //axleWeightLimitFront?
      //axleWeightLimitRear?
      //tyreDimensionFront?
      //tyreDimensionRear?
      //tyreLoadIndexFront?
      //tyreLoadIndexRear?
      //tyreSpeedIndexFront?
      //tyreSpeedIndexRear?
      //inspectionNextDate?
      //inspectionPrevDate?
      //ownername?
      //existingVehicleId?
      vehicleGuid: response.vehicleGuid,
      vehicleType: response.vehicleType
    }
  }

  async getDMSVehicleDetails(vehicleNo: string, _isSearch: boolean) {
    await this.vehicleService.getVehicleDetailsFromDMSByVehicleno(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        this.vehicleDetails = response.responseObject[0];
        this.vehicle = this.vehicleDetails.vehicles[0];
        this.localVehicleDetails = null;
        this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
        this.spinner.hide();
      }
    })
  }

  async getDFVehicleDetails(vehicleNo: string, isSearch: boolean) {
    await this.vehicleService.getVehicleDetailsByVehicleno(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response?.responseObject == null ||
          response.responseObject[0] == undefined ||
          response.responseObject[0].personDetail == undefined ||
          response.responseObject[0].personDetail == null) {
          this.vehicleDetails = null;
          this.localVehicleDetails = null;
          let errorMsg = this.translate.instant('lblVehicleDetailsNotFound');
          if (!isSearch) {
            this.addDFNotFoundCustomerVehicle();
          } else {
            this.toastr.error(errorMsg);
          }
        } else {
          this.VehicleSource = EnvSetting.ThirdPartyVehicleSource;
          this.vehicleDetails = response.responseObject[0];
          this.vehicle = this.vehicleDetails.vehicles[0];
          this.localVehicleDetails = null;
          this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
        }

        this.spinner.hide();
      }

    },
      _error => {
        this.spinner.hide();
      });

  }
  showVehicleDetails(isSearch: boolean) {
    this.ISalreadyAddedLP = false;
    if (this.vehicleNo != null && this.vehicleNo != "") {
      if (this.existingVehicleCustomerDetails != null && this.existingVehicleCustomerDetails != undefined) {
        this.existingVehicleCustomerDetails.forEach((element) => {
          if (element.licensePlateNo != null || element.licensePlateNo != undefined) {
            if (element.licensePlateNo.toLowerCase() == this.vehicleNo.toLowerCase()) {
              let alreadyAddedLP = this.translate.instant('lblalreadyAddedLP')
              this.toastr.warning(alreadyAddedLP);
              this.ISalreadyAddedLP = true;
            }
          }
        });
      }
      let tpVehicleSearch = false;
      if (this.secureStorage.getKeyData('feature')) {
        this.features = this.secureStorage.getKeyData('feature');
        if (this.features?.length > 0) {
          tpVehicleSearch = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.ThirdPartyAPI)?.isActive
        }
      }
      if (!this.ISalreadyAddedLP && tpVehicleSearch) {
        this.getVehicleDetails(this.vehicleNo, isSearch);
      }
    }
    else {
      let errorMsg = this.translate.instant('lblPleaseEnterVehicleNumber')
      this.toastr.error(errorMsg);
    }
  }

  addDFNotFoundCustomerVehicle() {
    this.VehicleSource = 'Manual';
    this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, undefined, null);
  }

  createMobileValidationModel(mobileNo: string, mobileCode: string): MobileValidationModel {
    return {
      MobileNo: mobileNo,
      MobileCode: mobileCode
    }
  }
  changeMobile() {
    this.showLPSearch = false;
    // this.vehicleNo = null;
  }


  async generateAndSendOtp(): Promise<void> {
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.isOTP = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.OTP)?.isActive
      }
    }
    if (this.isOTP) {
      const model = {
        MobileCode: this.userForgotAuthMobilecode,
        MobileNo: this.mobileNumber?.number.replace(/\s/g,''),
        LanguageCode: this.currentLanguage,
      }
      const invalidOTP = this.translate.instant("lblOTPsend")
      const OTPExpire = this.translate.instant("lblOTPNotsend")
      await this.findCarDataSevice.AddMobileOTPDetails(model).then((res) => {
        if (res.responseObject.result) {
          this.toastr.success(invalidOTP)
          this.resetAndCallOtpTimer();
          this.changeSection(this.sectionConstants.forgetRegOtpSection);

        }
        else {
          this.toastr.error(OTPExpire)
          this.timeout = true;
          this.changeSection(this.sectionConstants.forgetRegOtpSection);

        }
      })
    }
    else {
      // await this.verifyOtp();
      this.changeSection(this.sectionConstants.forgetRegOtpSection);
    }
    await this.resetAndCallOtpTimer();
    this.spinner.hide();
  }

  resetAndCallOtpTimer() {
    this.minute = '0';
    this.second = '0';
    this.timerOn = true;
    this.timeout = false;
    this.timer(+(EnvSetting.otpExpireTime) * 60);
  }

  backFromForgotSection(): void {
    this.changeSection(this.sectionConstants.registrationNumberSection);
  }

  onAddCar() {
    this.showLPSearch = true;
    this.vehicleNo = '';
  }
  async onOTPSubmit(): Promise<void> {
    // api call to validate otp
    this.commonService.addUserAuthMobile(this.customerPhoneNumber);
    this.commonService.validateCustomer();
    this.spinner.show();
    await this.verifyOtp();
  }
  async onOTPSubmit_WCVLS(): Promise<void> {
    // api call to validate otp
    this.commonService.addUserAuthMobile(this.customerPhoneNumber);
    this.commonService.validateCustomer();
    this.spinner.show();
    await this.verifyOtp_WCVLS();
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  onchange(event, form: NgForm) {
    let isnum = /^\d+$/.test(event.target.value);
    if (!isnum) {
      if(this.mobileNumber?.number){
        this.mobileNumber.number = '';
      } else {
        this.mobileNumber = '';
      }
      event.preventDefault();
      form.resetForm();
    }
  }
  getCustomerVehicleExistingDetails(isAPICallForGetVehicle = true, result: any = null) {
    if (isAPICallForGetVehicle) {
      let mobileCode = this.commonService.getUserAuthMobileCode();
      this.fcService.getCustomerAndVehicleDetailsUsingMobile(this.customerPhoneNumber, mobileCode)
        .then((result) => {
          this.customerVehicleDetail(result);
        });
    }
    else {
      this.customerVehicleDetail(result);
    }
  }
  customerVehicleDetail(result: any) {
    const responseObject = result.responseObject;
    if (responseObject && responseObject.errorCount > 0) {

      const errorObject = responseObject.result;
      if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.ParamNotFoundErrorCode) {
        let Msg = this.translate.instant('lblParamsNotFound')
        this.toastr.error(Msg);
      } else if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.CustomerNotFoundErrorCode) {
        this.existingVehicleCustomerDetails = [];

        this.multipleCarSelectionForm = new FormGroup({
          selectedCar: new FormControl(null, [Validators.required])
        });
        this.commonService.validateOtp();
        this.changeSection(this.sectionConstants.carSelectionMultiple);
      }
    } else {
      let car: any;
      if (responseObject.result?.length > 0) {
        this.existingCustomerID = responseObject.result[0].existingCustomerId;
        this.existingcustomerGuid = responseObject.result[0].existingcustomerGuid;
        car = this.isWidgetVehicleDMSSearch
          ? responseObject.result.filter(x => x.vehicleGuid !== null && x.vehicleGuid !== undefined)
          : responseObject.result.filter(x => x.existingVehicleId !== null && x.existingVehicleId !== undefined);
      }


      if (car && car.length > 0) {
        this.existingVehicleCustomerDetails = car as WidgetCustomerVehicleDetails[];
      }
      else {
        this.existingVehicleCustomerDetails = [];
      }
      this.multipleCarSelectionForm = new FormGroup({
        selectedCar: new FormControl(null, [Validators.required])
      });
      this.commonService.validateOtp();
      this.changeSection(this.sectionConstants.carSelectionMultiple);
    }
    if (this.existingVehicleCustomerDetails.length > 0) {
      let car: any;
      car = this.isWidgetVehicleDMSSearch
        ? responseObject.result.filter(x => x.vehicleGuid !== null && x.vehicleGuid !== undefined)
        : this.existingVehicleCustomerDetails.filter(x => x.existingVehicleId !== null && x.existingVehicleId !== undefined);

      this.iscar = (car.length > 0);
    }
    this.commonService.addExistingCustomerVehicleDetails(this.existingVehicleCustomerDetails);
    //if only single vehicle associated then select that default
    if (this.existingVehicleCustomerDetails.length === 1) {
      this.multipleCarSelectionForm.controls['selectedCar'].setValue(0);
      this.onMultipleCarSelectionFormSubmit()
    }

  }

  async verifyOtp(): Promise<void> {
    // // verify OTP
    // if (!this.isOTP) {
    //   this.getCustomerVehicleExistingDetails();
    // }
   if(this.OTP?.length === 6 )
    //if(this.OTP?.length === 6 && (this.isOTP))
    {
        const invalidOTP= this.translate.instant("lblInvalidOTP")
        const OTPExpire= this.translate.instant("lblOTPExpire")
        const model=
        {
          MobileCode: this.mobileNumber?.dialCode.replace('+',''),
          MobileNumber: this.customerPhoneNumber.replace(/\s+/g, ''),
          Otp: this.OTP,
        }
        await this.appointmentService.ValidateMobileOtp(model).then((res)=>{
          if (res.responseObject.token) {
            ClientAppLogin(res.responseObject.token);
            this.cultureLocaleService.initialise();
          }
          if(res.responseObject.result?.length>0 || res.responseObject.result.errorCode === CommonEnums.ErrorCodes.CustomerNotFoundErrorCode)
          {
            let verifiedCustdetails = res.responseObject.result as VerifiedCustomer;
            this.commonService.validateCustomer();
            this.globalSetting.isAuthenticated.next(true);
            this.timerOn = false;
            this.OTP = '';
            this.validOTP = true;
            if(verifiedCustdetails != null)
            {
              this.getCustomerVehicleExistingDetails(false,res);
            }
          }
          else if(res.responseObject.result?.length==0)
          {
            this.getCustomerVehicleExistingDetails(false,res);
          }
          else if(res.responseObject.result.errorCode === CommonEnums.ErrorCodes.InvalidOTP)
          {
            this.OTP='';
            this.toastr.error(invalidOTP);
          }
          else if(res.responseObject.result.errorCode === CommonEnums.ErrorCodes.OTPTimeOut)
          {
            this.OTP='';
            this.toastr.error(OTPExpire);
          }
        }).finally(()=>{
          this.spinner.hide();
        });
    }
    this.spinner.hide();
  }


  ResendOTP() {
    this.timerOn = false;
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    if (this.isOTP) {
      const model = {
        MobileCode: this.userForgotAuthMobilecode,
        MobileNo: this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber,
        LanguageCode: this.currentLanguage,
      }
      const invalidOTP = this.translate.instant("lblOTPsend")
      const OTPExpire = this.translate.instant("lblOTPNotsend")
      this.findCarDataSevice.AddMobileOTPDetails(model).then((response) => {
        if (response.responseObject.result) {
          this.toastr.success(invalidOTP)
          this.resetAndCallOtpTimer();
          this.changeSection(this.sectionConstants.forgetRegOtpSection);

        }
        else {
          this.toastr.error(OTPExpire)
          this.timeout = true;
          this.changeSection(this.sectionConstants.forgetRegOtpSection);

        }
      })
    }
    else {
      this.successMsg = true;
      setTimeout(() => this.successMsg = false, 3000);
      this.resetAndCallOtpTimer();
    }
  }

  onChangePhoneNo(): void {
    this.showTempOTPSection = false;
    this.showLPSearch = false;
    this.sections.carSelectionSingle = false;
    this.hideMobileNo = false;
    this.isUserForgotAuthCountryCodeSet = true;
    this.timerOn = false;
    this.OTP = '';
    this.changeSection(this.sectionConstants.forgetRegPhoneNumberSection);
  }
  onChangePhoneNo_WCVLS(): void {
    this.showTempOTPSection = false;
    this.showLPSearch = false;
    this.sections.carSelectionSingle = false;
    this.hideMobileNo = false;
    this.isUserForgotAuthCountryCodeSet = true;
    this.timerOn = false;
    this.OTP = '';
    this.isshowOTP = false;
    this.isshowmobilenumber = true;
  }

  setValuesAndNavigate() {
    this.commonService.completePanel(Enums.PanelIds.Panel1);
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel2);
  }

  changePanelTitle() {
    this.appData.licensePlate = this.licensePlate;
    this.commonService.changePanelTitle();
  }

  onMultipleCarSelectionFormSubmit(): void {
    const index = +this.multipleCarSelectionForm.controls.selectedCar.value;
    this.existingVehicleCustomerDetails = this.commonService.getExistingCustomerVehicleDetails();
    this.commonService.addSelectedCustomerVehicleDetails(this.existingVehicleCustomerDetails[index])
    this.commonService.completePanel(Enums.PanelIds.Panel1);
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel2);
  }

  onSelectCar(event: any, i: any) {
    //if selected car & index match and radio button is true then make it unselect
    if (i === this.multipleCarSelectionForm.controls.selectedCar.value && event.target.checked === true) {
      event.currentTarget.checked = false;
      this.multipleCarSelectionForm.controls['selectedCar'].setValue(null);
    }
  }
  initializeCarDetails(): void {
    this.existingVehicleCustomerDetails = this.commonService.getExistingCustomerVehicleDetails();
    this.selectedCustomerVehicleDetails = this.commonService.getSelectedCustomerVehicleDetails();
    this.existingCustomerID = this.existingVehicleCustomerDetails[0]?.existingCustomerId;
    this.existingcustomerGuid = this.existingVehicleCustomerDetails[0]?.customerGuid;
    const appdata = this.commonService.getAppData();
    if (this.existingVehicleCustomerDetails && this.selectedCustomerVehicleDetails) {
      const index = this.existingVehicleCustomerDetails.findIndex(x => x.existingVehicleId === this.selectedCustomerVehicleDetails.existingVehicleId && x.existingCustomerId === this.selectedCustomerVehicleDetails.existingCustomerId);
      this.multipleCarSelectionForm = new FormGroup({
        selectedCar: new FormControl(index, [Validators.required])
      });
      this.changeSection(this.sectionConstants.carSelectionMultiple);
      this.showTempOTPSection = false;
      this.hideMobileNo = true;
      this.showLPSearch = false;
      if (this.existingVehicleCustomerDetails.length > 0) {
        let car = this.existingVehicleCustomerDetails.filter(x => x.licensePlateNo != null && x.licensePlateNo != undefined);
        this.iscar = (car.length > 0);
      }
    }
    if (appdata.userAuthMobile) {
      this.mobileCode = appdata.userAuthMobileCode;
      this.mobileNumber = appdata.userAuthMobile;
      this.userAuthMobilecode = appdata.userAuthMobileCode;
    }
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();


  }

  initializeCustomerAndSingleVehicleDetails() {
    const appdata = this.commonService.getAppData();
    this.vehicleCustomerDetailsSingle = {
      customerGuid: appdata.customerDetails.customerGuid,
      firstName: appdata.customerDetails.firstName,
      lastName: appdata.customerDetails.lastName,
      address1: appdata.customerDetails.address1,
      address2: appdata.customerDetails.address2,
      zipcode: appdata.customerDetails.zipcode,
      city: appdata.customerDetails.city,
      state: appdata.customerDetails.state,
      country: appdata.customerDetails.country,
      mobileNo: appdata.customerDetails.mobileNo,
      email: appdata.customerDetails.email,
      latitude: appdata.customerDetails.latitude,
      longitude: appdata.customerDetails.longitude,
      vehicleGuid: appdata.selectedVehicleDetails.vehicleGuid,
      licensePlate: appdata.selectedVehicleDetails.licensePlate,
      engineSerialNo: appdata.selectedVehicleDetails.engineSerialNo,
      makeCode: appdata.selectedVehicleDetails.makeCode,
      model: appdata.selectedVehicleDetails.model,
      makeName: appdata.selectedVehicleDetails.makeName,
      mchCode: appdata.selectedVehicleDetails.mchCode,
      registrationDate: appdata.selectedVehicleDetails.registrationDate,
      color: appdata.selectedVehicleDetails.color,
      year: appdata.selectedVehicleDetails.year,
      chassisNo: appdata.selectedVehicleDetails.chassisNo,
      mobileCode: appdata.customerDetails.mobileCode,
      previousKilometer: appdata.selectedVehicleDetails.previousKilometer
    };
  }

  changeSection(key: string): void {
    if (key === this.sectionConstants.forgetRegPhoneNumberSection)
      this.timerOn = false;
    if (this.selectedCustomerVehicleDetails && this.isAddedNewVehicle === false) {
      this.licensePlate = this.selectedCustomerVehicleDetails?.licensePlateNo;
    }
    Object.keys(this.sections).forEach(x => {
      if (x === key) {
        this.sections[x] = true;
      } else {
        this.sections[x] = false;
      }
    });
  }
  ChangePhoneNoBack() {
    this.changeSection(this.sectionConstants.forgetRegPhoneNumberSection);
    this.hideMobileNo = false;
    this.showLPSearch = false;
    this.commonService.OnChangePhoneNoBack();
  }

  validateLicensePlateField(flag: string): void {
    this.licenseFlag = flag ? 'false' : 'true';
    this.changePanelTitle()

  }
  
  telForgetInputObject() {
    this.spinner.show();
    if (this.userForgotAuthCountryCode != undefined && this.userForgotAuthCountryCode != '' && this.isUserForgotAuthCountryCodeSet) {
      this.selectedCountryISO= this.userForgotAuthCountryCode;
      this.isUserForgotAuthCountryCodeSet = false;
    }
    else {
      this.mobileNumber = '';
      this.commonService.addUserAuthMobile(this.mobileNumber);
      this.selectedCountryISO= this.cultureLocaleService.getLocale();
    }
    this.spinner.hide();
  }

  onMobileNoEnter() {
    this.validateMobileNumberField(this.forgetRegPhoneNumberForm.valid as unknown as string)
    this.onForgotRegFormSubmit(this.forgetRegPhoneNumberForm)
  }

  onMobileNoEnter__WCVLS() {
    this.validateMobileNumberField(this.PhoneNumberForm.valid as unknown as string)
    this.onForgotRegFormSubmit(this.PhoneNumberForm)
  }

  onCountryChange(obj) {
    this.userAuthMobilecode = obj.dialCode;
    this.commonService.addUserAuthMobileCode(this.userAuthMobilecode);
    if (this.appData.customerDetails)
      this.appData.customerDetails.mobileCode = this.userAuthMobilecode;
    this.cdref.detectChanges();
  }
  validateMobileNumberField(flag: string): void {
    this.mobileNumberFlag = flag ? 'false' : 'true';
  }

  validateMobileNumberFieldandMobileNumber(flag: string): void {
    this.mobileNumberFlag = flag ? 'false' : 'true';
    if (this.mobileNumberFlag != 'true') {
      if (this.isWSSBLP && !this.isWCVLS) {
        if (this.mobileNumberFlag != 'true') {
          this.showTempOTPSection = false;
          this.isshowmobilenumber = false;
          this.isshowOTP = true;
          this.customerPhoneNumber = this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber;
          this.commonService.addCustomerPhone(this.customerPhoneNumber);
          this.spinner.show();
          this.generateAndSendOtp();
        }
        else {
          if (this.mobileNumber?.number == '' || isNullOrUndefined(this.mobileNumber?.number)) {
            let errorMsg = this.translate.instant('lblPleaseEnterYourMobileNumber')
            this.toastr.error(errorMsg);
          } else {
            let errorMsg = this.translate.instant('lblPleaseEnterCorrectMobileNumber')
            this.toastr.error(errorMsg);
          }
        }
        this.spinner.hide();
      }
      else if (this.isWSSBLP && this.isWCVLS) {
        this.vehicleNo = this.licensePlate;
        this.spinner.show();
        this.customerPhoneNumber = this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber;
        // this.getCustomerVehicleExistingDetails();
        let mobileCode = this.commonService.getUserAuthMobileCode();
        this.fcService.getCustomerAndVehicleDetailsUsingMobile(this.customerPhoneNumber, mobileCode)
          .then((result) => {
            const responseObject = result.responseObject;
            if (responseObject && responseObject.errorCount > 0) {
              this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
            }
            else {
              let car: any;
              this.existingCustomerID = responseObject.result[0].existingCustomerId;
              this.existingcustomerGuid = responseObject.result[0].existingcustomerGuid;
              car = this.isWidgetVehicleDMSSearch
                ? responseObject.result.filter(x => x.vehicleGuid !== null && x.vehicleGuid !== undefined)
                : responseObject.result.filter(x => x.existingVehicleId !== null && x.existingVehicleId !== undefined);
              if (car.length > 0) {
                this.existingVehicleCustomerDetails = car as WidgetCustomerVehicleDetails[];
              }
              else {
                this.existingVehicleCustomerDetails = [];
                this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
              }
              this.multipleCarSelectionForm = new FormGroup({
                selectedCar: new FormControl(null, [Validators.required])
              });
              this.changeSection(this.sectionConstants.carSelectionMultiple);
            }
            if (this.existingVehicleCustomerDetails.length > 0) {
              let car: any;
              car = this.isWidgetVehicleDMSSearch
                ? responseObject.result.filter(x => x.vehicleGuid !== null && x.vehicleGuid !== undefined)
                : this.existingVehicleCustomerDetails.filter(x => x.existingVehicleId !== null && x.existingVehicleId !== undefined);
              if (car.filter(x => x.licensePlateNo == this.licensePlate).length > 0) {
                let iscaravailable = car.filter(x => x.licensePlateNo == this.licensePlate);
                this.existingVehicleCustomerDetails = this.commonService.getExistingCustomerVehicleDetails();
                this.commonService.addSelectedCustomerVehicleDetails(iscaravailable[0])
                this.commonService.addUserAuthMobile(this.customerPhoneNumber);
                this.commonService.completePanel(Enums.PanelIds.Panel1);
                this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel2);
              }
              else {
                this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
              }
            }
          });
      }
    }
    else {
      if (this.mobileNumber?.number == '' || isNullOrUndefined(this.mobileNumber?.number)) {
        let errorMsg = this.translate.instant('lblPleaseEnterYourMobileNumber')
        this.toastr.error(errorMsg);
      }
      else {
        let errorMsg = this.translate.instant('lblPleaseEnterCorrectMobileNumber')
        this.toastr.error(errorMsg);
      }
    }
    this.spinner.hide();
  }
  onMobileNumberFormSubmit(form: NgForm): void {
    if (this.mobileNumberFlag != 'true') {
      this.spinner.show();
      const appData = this.commonService.getAppData();
      this.currentLanguageService.currentLanguage.subscribe(x => {
        this.currentLanguage = x
      });
      if (this.isOTP) {
        const model = {
          PhoneNo: '+' + this.userAuthMobilecode + (this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber),
          DealerName: appData.selectedDealer.dealerName,
          LanguageCode: this.currentLanguage,
          DealerId: appData.selectedDealer.dealerId
        }
        const invalidOTP = this.translate.instant("lblOTPsend")
        const OTPExpire = this.translate.instant("lblOTPNotsend")
        this.vehicleService.AddCustomerMobile(model).then((res) => {
          if (res.responseObject.result) {
            this.toastr.success(invalidOTP)
            this.resetAndCallOtpTimer();
          }
          else {
            this.toastr.error(OTPExpire)
            this.timeout = true;
          }
          this.spinner.hide();
        })
      }
      else {
        this.resetAndCallOtpTimer();
        this.spinner.hide();
      }
    } else {
      if (form.value.mobileNo.number == '' || isNullOrUndefined(form.value.mobileNo.number)) {
        let errorMsg = this.translate.instant('lblPleaseEnterYourMobileNumber')
        this.toastr.error(errorMsg);
      } else {
        let errorMsg = this.translate.instant('lblPleaseEnterCorrectMobileNumber')
        this.toastr.error(errorMsg);
      }
    }

  }

  onForgetCountryChange(obj) {
    this.showLPSearch = false;
    // this.vehicleNo = null;
    if (this.isInitialLoad) {
      this.telForgetInputObject();
      this.userForgotAuthMobilecode = this.userForgotAuthMobilecode || obj.dialCode;
      this.isInitialLoad = false;
    } else {
      this.userForgotAuthMobilecode = obj.dialCode;
    }
    this.commonService.addUserAuthMobileCode(this.userForgotAuthMobilecode);
    this.userForgotAuthCountryCode = obj.iso2;
    if (this.selectedCustomerVehicleDetails)
      this.selectedCustomerVehicleDetails.DIAL_CODE = this.userForgotAuthMobilecode;
  }

  timer(remaining: any) {
    this.minute = Math.floor(remaining / 60);
    this.second = remaining % 60;
    this.cdref.detectChanges();
    this.minute = this.minute < 10 ? '0' + this.minute : this.minute;
    this.second = this.second < 10 ? '0' + this.second : this.second;
    this.otpTimer = this.minute + ':' + this.second;
    remaining -= 1;
    this.cdref.detectChanges();
    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    this.timeout = true;
    const OTPExpire = this.translate.instant("lblOTPExpire")
    this.toastr.error(OTPExpire);
  }
  ngOnDestroy() {
    this.timerOn = false;
  }
  async verifyOtp_WCVLS(): Promise<void> {
    // verify OTP
    if (!this.isOTP) {
      this.getCustomerVehicleExistingDetails();
    }
    if (this.OTP?.length === 6 && (this.isOTP)) {
      const invalidOTP = this.translate.instant("lblInvalidOTP")
      const OTPExpire = this.translate.instant("lblOTPExpire")
      const model =
      {
        MobileCode: this.mobileNumber?.dialCode.replace('+',''),
        MobileNumber: this.customerPhoneNumber.replace(/\s+/g, ''),
        Otp: this.OTP,
      }
      await this.appointmentService.ValidateMobileOtp(model).then((res) => {
        if (res.responseObject.result.mobileNumber) {
          let verifiedCustdetails = res.responseObject.result as VerifiedCustomer;
          this.commonService.validateCustomer();
          this.timerOn = false;
          this.OTP = '';
          this.validOTP = true;
          if (verifiedCustdetails != null) {
            this.vehicleNo = this.licensePlate;
            this.spinner.show();
            this.customerPhoneNumber = this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber;
            let mobileCode = this.commonService.getUserAuthMobileCode();
            this.fcService.getCustomerAndVehicleDetailsUsingMobile(this.customerPhoneNumber, mobileCode)
              .then((result) => {
                this.commonService.validateOtp();
                const responseObject = result.responseObject;
                if (responseObject && responseObject.errorCount > 0) {
                  this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
                }
                else {
                  let car: any;
                  this.existingCustomerID = responseObject.result[0].existingCustomerId;
                  this.existingcustomerGuid = responseObject.result[0].existingcustomerGuid;
                  car = this.isWidgetVehicleDMSSearch
                    ? responseObject.result.filter(x => x.vehicleGuid !== null && x.vehicleGuid !== undefined)
                    : responseObject.result.filter(x => x.existingVehicleId !== null && x.existingVehicleId !== undefined);
                  if (car.length > 0) {
                    this.existingVehicleCustomerDetails = car as WidgetCustomerVehicleDetails[];
                  }
                  else {
                    this.existingVehicleCustomerDetails = [];
                  }
                  this.multipleCarSelectionForm = new FormGroup({
                    selectedCar: new FormControl(null, [Validators.required])
                  });
                  this.changeSection(this.sectionConstants.carSelectionMultiple);
                }
                if (this.existingVehicleCustomerDetails.length > 0) {
                  let car: any;
                  car = this.isWidgetVehicleDMSSearch
                    ? responseObject.result.filter(x => x.vehicleGuid !== null && x.vehicleGuid !== undefined)
                    : this.existingVehicleCustomerDetails.filter(x => x.existingVehicleId !== null && x.existingVehicleId !== undefined);
                  if (car.filter(x => x.licensePlateNo == this.licensePlate).length > 0) {
                    let iscaravailable = car.filter(x => x.licensePlateNo == this.licensePlate);
                    this.existingVehicleCustomerDetails = this.commonService.getExistingCustomerVehicleDetails();
                    this.commonService.addSelectedCustomerVehicleDetails(iscaravailable[0])
                    this.commonService.completePanel(Enums.PanelIds.Panel1);
                    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel2);
                  }
                  else {
                    this.openAddCustomerVehicleModal(false, this.customerPhoneNumber, this.userForgotAuthMobilecode, true, this.vehicleDetails, this.localVehicleDetails);
                  }
                }
              });
          }
        }
        else if (res.responseObject.result.errorCode === CommonEnums.ErrorCodes.InvalidOTP) {
          this.OTP = '';
          this.toastr.error(invalidOTP);
        }
        else if (res.responseObject.result.errorCode === CommonEnums.ErrorCodes.OTPTimeOut) {
          this.OTP = '';
          this.toastr.error(OTPExpire);
        }
      })
    }
    this.spinner.hide();
  }
}